import { render, staticRenderFns } from "./DialogoDeAprovacaoDoCertificado.vue?vue&type=template&id=52f5d920"
import script from "./DialogoDeAprovacaoDoCertificado.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogoDeAprovacaoDoCertificado.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports